import React from 'react';

interface LoyaltyStatusCardProps {
  tier?: string;
  subtitle?: string;
  currentPoints?: number;
  goal?: number;
  nextTierText?: string;
}

export const LoyaltyStatusCard: React.FC<LoyaltyStatusCardProps> = ({
  tier = 'Gold Tier',
  subtitle = 'Top 5% of customers',
  currentPoints = 2450,
  goal = 5000,
  nextTierText = '2,550 points needed for Platinum status',
}) => {
  const pct = goal > 0 ? Math.min(100, (currentPoints / goal) * 100) : 0;
  return (
    <div
      className="user-detail-loyalty-status-card"
      style={{
        borderRadius: 16,
        padding: 24,
        background: 'linear-gradient(135deg, #1e3a5f 0%, #0f172a 100%)',
        color: '#fff',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          right: 16,
          top: 16,
          opacity: 0.15,
          fontSize: 48,
        }}
      >
        ★
      </div>
      <div style={{ fontSize: 14, marginBottom: 4 }}>Loyalty Status</div>
      <div
        style={{
          fontSize: 22,
          fontWeight: 700,
          color: '#fbbf24',
          marginBottom: 4,
        }}
      >
        {tier}
      </div>
      <div style={{ fontSize: 13, opacity: 0.9, marginBottom: 16 }}>
        {subtitle}
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          fontSize: 12,
          marginBottom: 8,
        }}
      >
        <span>{currentPoints.toLocaleString()} Points</span>
        <span>Goal: {goal.toLocaleString()}</span>
      </div>
      <div
        style={{
          height: 8,
          borderRadius: 4,
          background: 'rgba(255,255,255,0.2)',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            width: `${pct}%`,
            height: '100%',
            background: '#fbbf24',
            borderRadius: 4,
          }}
        />
      </div>
      <div style={{ fontSize: 12, opacity: 0.9, marginTop: 8 }}>
        {nextTierText}
      </div>
    </div>
  );
};
